/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Fallback_DefaultInputs */



/**
* | output |
* | --- |
* | "Quota reached. This response used oneAI Standard (free)." |
*
* @param {Chat_Fallback_DefaultInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_fallback_default = /** @type {((inputs?: Chat_Fallback_DefaultInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Fallback_DefaultInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kontingent erreicht. Diese Antwort verwendete oneAI Standard (kostenlos).")
	return /** @type {LocalizedString} */ ("Quota reached. This response used oneAI Standard (free).")
});